import { usePropsResolution } from 'native-base';
import { StyleSheet } from 'react-native';

import { getDesignToken } from 'styles/constants';

import { addWithConfig } from '../../utils';
import { Box } from '../box';
import { Icon } from '../icon';
import { Typography } from '../text/Typography';

import type { BadgeProps } from './types';

export const Badge = ({
  accessibilityLabel,
  iconName,
  iconSize = 'xs',
  children,
  variant,
  ...props
}: BadgeProps) => {
  const resolvedProps = usePropsResolution('Badge', { variant, ...props });

  const defaultVariant = ['default-solid', 'default-outline', 'default-subtle'].includes(variant);
  const showIcon = defaultVariant && iconName;

  const iconColor = resolvedProps.color;

  return (
    <Box {...resolvedProps} accessibilityLabel={accessibilityLabel}>
      {showIcon && <Icon variant={iconName} size={iconSize} mr="$1" color={iconColor} />}
      {typeof children === 'string' ? (
        <Typography
          maxFontSizeMultiplier={1}
          color={textStyles[variant].color}
          fontSize={(props._text?.fontSize as any) || 'xs'}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </Box>
  );
};

const textStyles = StyleSheet.create({
  'default-solid': {
    color: getDesignToken('text-reversed'),
  },
  'default-outline': {
    color: getDesignToken('text-default'),
  },
  'default-subtle': {
    color: getDesignToken('text-default'),
  },
  'number-solid': {
    color: getDesignToken('text-reversed'),
  },
  'number-outline': {
    color: getDesignToken('text-default'),
  },
  'number-subtle': {
    color: getDesignToken('text-default'),
  },
});

export default addWithConfig(Badge);
